import { PANORAMA_MARKER_GREEN, PANORAMA_MARKER_ORANGE } from '../../wrapper/constants/index.ts';

const _spriteTextures = { green: null, orange: null };

export function getSpriteTexture(color = 'green') {
    if (!_spriteTextures[color]) {
        const url = color === 'orange' ? PANORAMA_MARKER_ORANGE : PANORAMA_MARKER_GREEN;
        _spriteTextures[color] = new THREE.TextureLoader().load(url);
    }
    return _spriteTextures[color];
}

export function setPanoramaMarkerColor(viewer, markerColor) {
    if (!viewer || !viewer.scene || !viewer.scene.images360) {
        return;
    }

    const texture = getSpriteTexture(markerColor);

    viewer.scene.images360.forEach((images360Instance) => {
        for (const image360 of images360Instance.images) {
            if (image360.mesh && image360.mesh.material) {
                image360.mesh.material.map = texture;
                image360.mesh.material.needsUpdate = true;
            }
        }
    });
}
